import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';
import {DraggableContainer, DraggableItem} from 'views/components';
import {Translate} from 'views/module';

import CareViewItem from './view/CareViewItem';
import CareViewResetQuestions from './view/CareViewResetQuestions';
import CareViewItemNew from './view/CareViewItemNew';

const CareviewSettings = (props) => {
  const [careviewList, setCareviewList] = React.useState([]);
  const [isReseting, setIsReseting] = React.useState(false);
  const [isCreatingNew, setIsCreatingNew] = React.useState(false);

  const clientCareviewSettings = props.clientCareviewSettings;
  const clientBackend = props.clientBackend;

  React.useEffect(() => {
    const careviewQuestions = clientCareviewSettings?.careviewQuestions;

    if (!careviewQuestions) {
      setCareviewList([]);
    } else {
      const careviewQuestionsList = Object.values(clientCareviewSettings.careviewQuestions);
      const careviewQuestionsListSorted = careviewQuestionsList.sort((a, b) => a.rankorder - b.rankorder);
      setCareviewList(careviewQuestionsListSorted);
    }
  }, [clientCareviewSettings]);


  const onDrop = ({removedIndex, addedIndex, payload}) => {
    if (removedIndex === addedIndex) {
      return;
    }
    setCareviewList((prev) => {
      const removed = prev.splice(removedIndex, 1);
      prev.splice(addedIndex, 0, removed[0]);
      const newList = [...prev];
      reorderList(newList);
      return newList;
    });
  };

  const addQuestion = (type, questionData, onSuccess=()=>undefined) => {
    clientBackend.careview.addQuestion(type, questionData, onSuccess);
  };

  const updateQuestion = (questionRn, questionData, onSuccess=()=>undefined) => {
    clientBackend.careview.updateQuestion(questionRn, questionData, onSuccess);
  };

  const deleteQuestion = (questionRn, onSuccess=()=>undefined) => {
    clientBackend.careview.deleteQuestion(questionRn, onSuccess);
  };

  const reorderList = async (newList, onSuccess=()=>undefined) => {
    const reorderList = newList.map((e, index) => {
      return {
        questionRn: e.questionRn,
        rankorder: index,
      };
    });

    clientBackend.careview.reorderQuestions(reorderList, onSuccess);
  };

  const resetQuestions = () => {
    setIsReseting(true);
    const onSuccess = () => {
      setIsReseting(false);
    };
    clientBackend.careview.resetQuestions(onSuccess);
  };

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={1}
    >
      <DraggableContainer
        dragHandleSelector='.drag-handle'
        lockAxis='y'
        onDrop={onDrop}
      >
        {
          careviewList.map((e, index) => {
            return (
              <DraggableItem
                key={e.questionRn}
              >
                <CareViewItem
                  index={index + 1}
                  careviewItem={e}
                  updateQuestion={(questionData, onSuccess) => updateQuestion(e.questionRn, questionData, onSuccess)}
                  deleteQuestion={(onSuccess) => deleteQuestion(e.questionRn, onSuccess)}
                />
              </DraggableItem>
            );
          })
        }
      </DraggableContainer>
      <Stack
        spacing={1}
        direction='row'
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          onClick={() => setIsCreatingNew(true)}
        >
          <Translate
            expression='client.ClientDetail.CareviewSettings.NewQuestion.Action'
          />
        </Button>
        <Button
          onClick={() => setIsReseting(true)}
          variant='outlined'
          color='error'
        >
          <Translate
            expression='client.ClientDetail.CareviewSettings.ResetQuestions.Action'
          />
        </Button>
      </Stack>
      {
        isReseting &&
        <CareViewResetQuestions
          resetQuestions={resetQuestions}
          close={() => setIsReseting(false)}
        />
      }
      {
        isCreatingNew &&
        <CareViewItemNew
          addQuestion={addQuestion}
          close={() => setIsCreatingNew(false)}
        />
      }
    </Stack>
  );
};

CareviewSettings.propTypes = {
  clientCareviewSettings: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
};
export default React.memo(CareviewSettings);
